// Vendor
import { createApp, h } from 'vue';
import { createI18n } from 'vue-i18n';
import domready from 'domready';
// Widgets
import WidgetSituation from './components/WidgetSituation.vue';
import WidgetFlow from './components/WidgetFlow.vue';
import WidgetFrequency from './components/WidgetFrequency.vue';
import PowerBalance from './components/PowerBalance.vue';

const apps = {
    '#widget-situation': WidgetSituation,
    '#widget-flow': WidgetFlow,
    '#widget-frequency': WidgetFrequency,
};

domready(function() {
    mountApps();
    window.addEventListener('statnett:apps-updated', mountApps);
});

function mountApps() {
    const translations = getTranslations();
    const vm = getVm();
    const registeredApps = {
        ...apps,
        ...getPowerBalanceApps(vm),
    };

    Object.entries(registeredApps).forEach(([selector, component]) => {
        const el = document.querySelector(selector);
        const props = vm && vm[selector];
    
        if(!el || !props || el.__statnettVueApp) {
            return;
        }

        const i18n = createI18n({
            legacy: false,
            globalInjection: true,
            locale: 'no',
            messages: {
                no: translations,
            },
        });

        const app = createApp({
            render() {
                return h(component, getComponentProps(props));
            },
        });

        app.use(i18n);
        app.mount(el);
        el.__statnettVueApp = app;
    });
}

function getPowerBalanceApps(vm) {
    return Object.fromEntries(
        Object.keys(vm || {})
            .filter(selector => selector.startsWith('#power-balance-'))
            .map(selector => [selector, PowerBalance])
    );
}

function getTranslations() {
    if(!window._statnett) {
        return {};
    }

    let translations = {};
    
    const resources = Object.keys(window._statnett).map(app => {
        return translations = {
            ...translations,
            ...window._statnett[app].resources,
        };
    });

    return translations;
}

function getVm() {
    if(!window._statnett) {
        return undefined;
    }

    return window._statnett;
}

function getComponentProps(props) {
    const { resources, ...componentProps } = props;

    return componentProps;
}
